export default {
	meters: {
		meter_details: 'Zählerdetails',
		meter_number: 'Zählernummer',
		licensed_by: 'Lizenziert von',
		meter_type: 'Zählerart',
		responsible_for_measurement: 'Verantwortlich für die Messung',
		type_of_reading: 'Art der Messung',
		removed_at: 'Ausgebaut am',
		manufacturer: 'Hersteller',
		installed_on: 'Installiert am',
		model_year: 'Modelljahr',
		calibration_due_on: 'Kalibrierung fällig am',
		zeroable: 'Nullbar',
		consumption_information: 'Verbrauchsinformationen',
		record_reading: 'Stand erfassen',
	},
}
